<template>
  <section class="w-[85em] flex flex-col">
    <ImageUploadDropzone @refetch-images="getWebsiteImages"/>

    <div class="grow min-h-[33.5em]">
      <ul role="list" class="grid grid-cols-7 gap-3 p-4">
        <template v-if="loading">
          <li v-for="(img, index) in 20" :key="index">
            <div class="ske group aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-primary-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100">
              <img src="https://images.unsplash.com/photo-1582053433976-25c00369fc93?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=512&q=80" alt="" class="pointer-events-none object-cover duration-100 group-hover:opacity-75">
            </div>
          </li>
        </template>
        <template v-else>
          <li
            v-for="(src, index) in images"
            class="relative border border-gray-100 hover:border-gray-200 duration-100 rounded-lg group"
            :class="selected === src && '!border-gray-800'"
            :key="index"
            @click="selected !== src ? (selected = src) : (selected = null)"
          >
            <div class="group aspect-w-10 aspect-h-7 block w-full overflow-hidden rounded-lg bg-gray-100 focus-within:ring-offset-gray-100">
              <img :src="src" class="pointer-events-none object-cover group-hover:opacity-75">
              <button type="button" class="absolute inset-0 focus:outline-none">
                <span class="sr-only">View details for IMG_4985.HEIC</span>
              </button>
            </div>

            <svg v-if="selected === src" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-gray-800 w-6 h-6 absolute top-0 left-0 ml-2 mt-2">
              <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="absolute cursor-pointer hover:brightness-125 top-0 text-red-500 mr-1 mt-1 right-0 duration-200 opacity-0 group-hover:opacity-100 w-8 h-8" @click="deleteImg(src)">
              <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z" clip-rule="evenodd" />
            </svg>
          </li>
        </template>
      </ul>
    </div>
    <div class="flex shrink-0 justify-between px-4 py-4 border-t border-gray-200">
      <button
        type="button"
        class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-700 shadow-sm duration-100 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
        @click="$emit('close')"
      >
        Cancel
      </button>
      <div class="flex justify-between sm:justify-end">
        <button v-if="hasPrevious" class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" @click="page--">
          Previous
        </button>
        <button v-if="hasNext" class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50" @click="page++">
          Next
        </button>
      </div>
      <transition
        enter-class="opacity-0"
        leave-class="opacity-100"
        enter-to-class="opacity-100"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <button v-if="selected" type="submit" :disabled="!selected" class="inline-flex justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm duration-100 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2" @click="insertImage">
          Select image
        </button>
        <button v-else type="submit" :disabled="!selected" class="opacity-0 inline-flex justify-center rounded-md border border-transparent bg-blue-600 py-2 px-4 text-sm font-medium text-white shadow-sm duration-100 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2">
          Select image
        </button>
      </transition>
    </div>
  </section>
</template>

<script>

import ImageUploadDropzone from "@/components/SideEditor/ImageUploadDropzone"

const PAGE_SIZE = 40

export default {
  components: {
    ImageUploadDropzone,
  },
  props: ['websiteUid', 'value'],
  data() {
    return {
      results: [],
      loading: true,
      selected: this.value,
      total: 0,
      page: 0,
    }
  },
  created() {
    this.getWebsiteImages()
  },
  methods: {
    async deleteImg(src) {
      const item = this.results.find(item => item.url === src)
      await this.axios.delete(`/api/websites/${this.websiteUid}/files/${item.fid}`)
      this.$store.dispatch('clearCacheSearch', "websites")
      this.getWebsiteImages()
    },
    async getWebsiteImages() {
      this.loading = true

      const { results, total } = (await this.axios.get(`/api/websites/${this.websiteUid}/files`, {params: {page: this.page + 1, page_size: PAGE_SIZE}})).data
      this.total = total
      this.results = results

      this.loading = false
    },
    insertImage() {
      this.$emit("set-value", this.selected)
    },
  },
  computed: {
    images() {
      return this.results.map(item => item.url)
    },
    hasNext() {
      return this.currentOffset < PAGE_SIZE
    },
    hasPrevious() {
      return this.currentOffset >= PAGE_SIZE
    },
    currentOffset() {
      return this.page * PAGE_SIZE
    },
  },
  watch: {
    page() {
      this.getWebsiteImages()
    },
  },
}

</script>
